export class RegionType {
  province?: string = '';
  provinceCode?: string = '';
  city?: string = '';
  cityCode?: string = '';
  district?: string = '';
  districtCode?: string = '';
}
